import { AdminRole, PermissionLevel } from './constants'

const pathPageRules = [
  { test: (pathname) => /^\/(?:campaigns|course-quiz-campaigns)(?:\/|$)/.test(pathname), page: 'course-quiz-campaigns' },
  { test: (pathname) => pathname === '/', page: 'dashboard' },
  { test: (pathname) => /^\/events\/[^/]+\/manager(?:\/|$)/.test(pathname), page: 'event-manager' },
  { test: (pathname) => /^\/users\/students(?:\/|$)/.test(pathname), page: 'users/students' },
  { test: (pathname) => /^\/users\/teachers(?:\/|$)/.test(pathname), page: 'users/teachers' },
  { test: (pathname) => /^\/users\/tutors(?:\/|$)/.test(pathname), page: 'users/tutors' },
  { test: (pathname) => /^\/users\/admins(?:\/|$)/.test(pathname), page: 'users/admins' },
  { test: (pathname) => /^\/users\/companies(?:\/|$)/.test(pathname), page: 'users/companies' },
  { test: (pathname) => /^\/careers(?:\/|$)/.test(pathname), page: 'careers' },
  { test: (pathname) => /^\/courses(?:\/|$)/.test(pathname), page: 'courses' },
  { test: (pathname) => /^\/users(?:\/|$)/.test(pathname), page: 'users' },
  { test: (pathname) => /^\/messages(?:\/|$)/.test(pathname), page: 'messages' },
  { test: (pathname) => /^\/macros(?:\/|$)/.test(pathname), page: 'macros' },
  { test: (pathname) => /^\/notifications(?:\/|$)/.test(pathname), page: 'notifications' },
  { test: (pathname) => /^\/settings(?:\/|$)/.test(pathname), page: 'settings' },
  { test: (pathname) => /^\/profile(?:\/|$)/.test(pathname), page: 'profile' },
  { test: (pathname) => /^\/changePassword(?:\/|$)/.test(pathname), page: 'changePassword' },
  { test: (pathname) => /^\/orders(?:\/|$)/.test(pathname), page: 'orders' },
  { test: (pathname) => /^\/invoices(?:\/|$)/.test(pathname), page: 'invoices' },
  { test: (pathname) => /^\/videos(?:\/|$)/.test(pathname), page: 'videos' },
  { test: (pathname) => /^\/downloads(?:\/|$)/.test(pathname), page: 'downloads' },
  { test: (pathname) => /^\/materials(?:\/|$)/.test(pathname), page: 'materials' },
  { test: (pathname) => /^\/tests(?:\/|$)/.test(pathname), page: 'tests' },
  { test: (pathname) => /^\/exercises(?:\/|$)/.test(pathname), page: 'exercises' },
  { test: (pathname) => /^\/shop_courses(?:\/|$)/.test(pathname), page: 'shop_courses' },
  { test: (pathname) => /^\/reviews(?:\/|$)/.test(pathname), page: 'reviews' },
  { test: (pathname) => /^\/surveys(?:\/|$)/.test(pathname), page: 'surveys' },
  { test: (pathname) => /^\/applications-legacy(?:\/|$)/.test(pathname), page: 'applications' },
  { test: (pathname) => /^\/applications-v2(?:\/|$)/.test(pathname), page: 'applications' },
  { test: (pathname) => /^\/applications(?:\/|$)/.test(pathname), page: 'applications' },
  { test: (pathname) => /^\/communications(?:\/|$)/.test(pathname), page: 'communications' },
  { test: (pathname) => /^\/feedbacks(?:\/|$)/.test(pathname), page: 'feedbacks' },
  { test: (pathname) => /^\/coupons(?:\/|$)/.test(pathname), page: 'coupons' },
  { test: (pathname) => /^\/forms(?:\/|$)/.test(pathname), page: 'forms' },
  { test: (pathname) => /^\/mailings(?:\/|$)/.test(pathname), page: 'mailings' },
  { test: (pathname) => /^\/reports\/sales(?:\/|$)/.test(pathname), page: 'reports/sales' },
  { test: (pathname) => /^\/reports\/teaching(?:\/|$)/.test(pathname), page: 'reports/teaching' },
  { test: (pathname) => /^\/reports\/orders(?:\/|$)/.test(pathname), page: 'reports/orders' },
  { test: (pathname) => /^\/reports\/marketing(?:\/|$)/.test(pathname), page: 'reports/marketing' },
  { test: (pathname) => /^\/events(?:\/|$)/.test(pathname), page: 'events' },
  { test: (pathname) => /^\/lessons\/[^/]+\/recordings\/editor(?:\/|$)/.test(pathname), page: 'recordings-editor' },
  { test: (pathname) => /^\/lessons\/[^/]+(?:\/|$)/.test(pathname), page: 'live-lesson' },
  { test: (pathname) => /^\/lessons(?:\/|$)/.test(pathname), page: 'lessons' },
  { test: (pathname) => /^\/articles\/[^/]+\/preview(?:\/|$)/.test(pathname), page: 'article-preview' },
  { test: (pathname) => /^\/articles\/[^/]+\/editor(?:\/|$)/.test(pathname), page: 'article-editor' },
  { test: (pathname) => /^\/articles(?:\/|$)/.test(pathname), page: 'articles' },
  { test: (pathname) => /^\/jobs(?:\/|$)/.test(pathname), page: 'jobs' },
  { test: (pathname) => /^\/developers(?:\/|$)/.test(pathname), page: 'developers' },
]

const inheritedPagePermissions = {
  'recordings-editor': ['lessons'],
}

export const pagePermissionDefaults = {
  'course-quiz-campaigns': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  dashboard: PermissionLevel.All,
  careers: PermissionLevel.Media,
  users: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'users/students': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'users/teachers': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'users/tutors': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'users/admins': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'users/companies': PermissionLevel.Administration,
  messages: PermissionLevel.All,
  macros: PermissionLevel.Media,
  profile: PermissionLevel.All,
  changePassword: PermissionLevel.All,
  orders: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  invoices: PermissionLevel.Administration,
  videos: PermissionLevel.Media,
  downloads: PermissionLevel.Media,
  'recordings-editor': PermissionLevel.Media,
  shop_courses: PermissionLevel.Marketing,
  articles: PermissionLevel.Media,
  'article-editor': PermissionLevel.Marketing,
  'article-preview': PermissionLevel.Marketing,
  reviews: PermissionLevel.Media,
  surveys: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'live-lesson': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  applications: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  communications: PermissionLevel.Administration,
  feedbacks: PermissionLevel.Marketing,
  coupons: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'reports/sales': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'reports/teaching': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'reports/orders': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'reports/marketing': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  forms: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  mailings: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  events: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  'event-manager': [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
  notifications: PermissionLevel.All,
  developers: PermissionLevel.Administration,
}

export const alwaysEnabledPages = ['dashboard', 'profile', 'messages', 'notifications', 'changePassword']

export function isAlwaysEnabledPage(page) {
  return alwaysEnabledPages.includes(page)
}

export const navSectionsConfig = [
  { id: 'developers', permissionLevel: PermissionLevel.Administration },
  { id: 'users', permissionLevel: PermissionLevel.Marketing },
  {
    id: 'content',
    permissionLevel: PermissionLevel.Media,
    children: [
      { id: 'macros' },
      { id: 'careers' },
      { id: 'videos' },
      { id: 'downloads' },
      { id: 'articles' },
      { id: 'reviews' },
    ],
  },
  {
    id: 'teaching',
    children: [
      { id: 'lessons' },
      { id: 'courses' },
      { id: 'exercises' },
      { id: 'materials' },
      { id: 'tests' },
      { id: 'communications' },
    ],
  },
  {
    id: 'shop',
    permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
    children: [
      { id: 'shop_courses', permissionLevel: PermissionLevel.Marketing },
      { id: 'orders', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
      { id: 'invoices', permissionLevel: PermissionLevel.Administration },
      { id: 'coupons', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
    ],
  },
  { id: 'events', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
  { id: 'applications', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
  { id: 'forms', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
  { id: 'mailings', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
  { id: 'course-quiz-campaigns', path: '/campaigns', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
  { id: 'surveys', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
  { id: 'feedbacks', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
  {
    id: 'reports',
    permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing],
    children: [
      { id: 'reports/sales', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
      { id: 'reports/teaching', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
      { id: 'reports/orders', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
      { id: 'reports/marketing', permissionLevel: [...PermissionLevel.Sales, ...PermissionLevel.Marketing] },
    ],
  },
  { id: 'settings' },
  { id: 'jobs' },
]

const permissionEditorExtraPages = [
]

const applicationPermissionSubPages = [
  { id: 'applications' },
  {
    id: 'applications/sales-performance',
    label: 'Performance di vendita',
    parentId: 'applications',
    viewOnly: true,
    defaultAllowed: false,
  },
]

const usersPermissionSubPages = [
  { id: 'users' },
  {
    id: 'users/students',
    label: 'Studenti',
    parentId: 'users',
  },
  {
    id: 'users/teachers',
    label: 'Docenti',
    parentId: 'users',
  },
  {
    id: 'users/tutors',
    label: 'Tutor',
    parentId: 'users',
  },
  {
    id: 'users/admins',
    label: 'Admin',
    parentId: 'users',
  },
  {
    id: 'users/companies',
    label: 'Aziende',
    parentId: 'users',
  },
]

const navPermissionGroups = navSectionsConfig
  .filter((section) => section.children && section.children.length > 0)
  .map((section) => ({
    id: section.id,
    pages: section.children.map((child) => ({ id: child.id })),
  }))

const navSinglePages = navSectionsConfig
  .filter((section) => !section.children || section.children.length === 0)
  .filter((section) => section.id !== 'applications' && section.id !== 'users')
  .map((section) => ({ id: section.id }))

export const permissionEditorSectionsConfig = [
  {
    id: 'general',
    pages: [...permissionEditorExtraPages, ...navSinglePages],
  },
  {
    id: 'users',
    pages: usersPermissionSubPages,
  },
  {
    id: 'applications',
    pages: applicationPermissionSubPages,
  },
  ...navPermissionGroups,
]

export const permissionPagesConfig = [
  ...permissionEditorSectionsConfig.flatMap((section) => section.pages),
].filter((item, index, array) => array.findIndex((current) => current.id === item.id) === index)

export function getPageKeyFromPath(pathname = '') {
  const rule = pathPageRules.find((item) => item.test(pathname))
  return rule?.page ?? null
}

export function getDefaultPermissionLevel(page) {
  return pagePermissionDefaults[page] ?? null
}

function normalizePermissionBoolean(rawValue) {
  if (rawValue === true || rawValue === 'true' || rawValue === 1 || rawValue === '1') {
    return true
  }
  if (rawValue === false || rawValue === 'false' || rawValue === 0 || rawValue === '0') {
    return false
  }
  return undefined
}

export function hasPagePermissionFlag(user, page, flag, defaultValue = false) {
  if (!user || !page || !flag) {
    return defaultValue
  }

  const rawValue = user?.permissions?.pages?.[page]?.[flag]
  const normalized = normalizePermissionBoolean(rawValue)
  if (normalized === undefined) {
    return defaultValue
  }

  return normalized
}

function getActionOverride(user, page, action) {
  if (!user || !page) {
    return undefined
  }

  const rawValue = user?.permissions?.pages?.[page]?.[action]
  const normalizedValue = normalizePermissionBoolean(rawValue)
  if (normalizedValue !== undefined) {
    return normalizedValue
  }

  const inheritedPages = inheritedPagePermissions[page] || []
  for (const inheritedPage of inheritedPages) {
    const inheritedValue = user?.permissions?.pages?.[inheritedPage]?.[action]
    const normalizedInheritedValue = normalizePermissionBoolean(inheritedValue)
    if (normalizedInheritedValue !== undefined) {
      return normalizedInheritedValue
    }
  }

  return undefined
}

export function canAccessPage(user, page, action = 'view', fallbackPermissionLevel = null) {
  if (!user) {
    return false
  }

  const companyAssociation = user?.company_id ?? user?.company?.id ?? user?.company
  const isCompanyAdmin = Boolean(companyAssociation)

  const isB2BTeachingCompanyAdmin = isCompanyAdmin && user?.company?.type === 'b2b_teaching'
  const isEventPartnerCompanyAdmin = isCompanyAdmin && user?.company?.type === 'event_partner'

  if (page === 'developers' && (!isCompanyAdmin || isB2BTeachingCompanyAdmin)) {
    return false
  }

  if (isCompanyAdmin) {
    if (!page) {
      return false
    }

    const baseCompanyPages = alwaysEnabledPages.filter((p) => p !== 'messages')
    const companyAdminAllowedPages = isB2BTeachingCompanyAdmin
      ? [...baseCompanyPages, 'users', 'users/students', 'users/admins']
      : isEventPartnerCompanyAdmin
        ? baseCompanyPages
        : [...baseCompanyPages, 'developers']

    return companyAdminAllowedPages.includes(page)
  }

  if (user.role === AdminRole.EventManager) {
    if (!page) {
      return false
    }

    const eventManagerAllowedPages = ['dashboard', 'profile', 'changePassword', 'event-manager']
    return eventManagerAllowedPages.includes(page)
  }

  if (isAlwaysEnabledPage(page)) {
    return true
  }

  const override = getActionOverride(user, page, action)
  const viewOverride = getActionOverride(user, page, 'view')
  const editOverride = getActionOverride(user, page, 'edit')

  // Keep actions consistent even for legacy/incomplete permission payloads.
  if (action === 'edit' && override === undefined && viewOverride === false) {
    return false
  }
  if (action === 'view' && override === undefined && editOverride === true) {
    return true
  }

  if (override === true) {
    return true
  }
  if (override === false) {
    return false
  }

  const resolvedFallback = Array.isArray(fallbackPermissionLevel)
    ? fallbackPermissionLevel
    : getDefaultPermissionLevel(page)

  if (Array.isArray(resolvedFallback)) {
    return resolvedFallback.includes(user.role)
  }

  // Maintain existing behavior for routes/items without explicit permissionLevel.
  return user.role === AdminRole.Main
}
